var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24421 10.7885C7.09247 10.7035 6.9075 10.7035 6.75577 10.7885L3.83159 12.4253C3.45929 12.6337 3.01382 12.3101 3.09695 11.8916L3.74995 8.6046C3.78384 8.43404 3.72667 8.25812 3.599 8.14006L1.13831 5.86471C0.825044 5.57503 0.995183 5.05133 1.41888 5.00108L4.74692 4.60637C4.91958 4.5859 5.06922 4.47718 5.14205 4.3193L6.54597 1.27595C6.72469 0.88854 7.27529 0.888539 7.45401 1.27595L8.85793 4.3193C8.93076 4.47718 9.08039 4.5859 9.25306 4.60637L12.5811 5.00108C13.0048 5.05133 13.1749 5.57503 12.8617 5.86471L10.401 8.14006C10.2733 8.25812 10.2161 8.43404 10.25 8.6046L10.903 11.8916C10.9862 12.3101 10.5407 12.6337 10.1684 12.4253L7.24421 10.7885Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3aa4a7fe.svg";
export { ForwardRef as ReactComponent };